import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginatedResult } from '../../../shared/models/paginated-result.model';
import {
  CreateShoppingSessionRequest,
  ShoppingSession,
  ShoppingSessionReference,
  Success,
  UpdateShoppingSessionRequest,
} from '../api.entities';
import { ApiService } from '../api.service';
import { PaginatedShoppingSessionQuery, ShoppingSessionQuery } from './queries/shopping-session.query';

@Injectable({
  providedIn: 'root',
})
export class ShoppingSessionsApi extends ApiService {
  create(body: CreateShoppingSessionRequest): Observable<ShoppingSession> {
    return this.request(this.client.POST('/api/shopping-sessions', { body }));
  }

  findAll(query: PaginatedShoppingSessionQuery): Observable<PaginatedResult<ShoppingSession>> {
    return this.request(this.client.GET('/api/shopping-sessions', { params: { query } }));
  }

  findAllCompact(query?: ShoppingSessionQuery): Observable<ShoppingSessionReference[]> {
    return this.request(this.client.GET('/api/shopping-sessions/compact', { params: { query } }));
  }

  findOne(id: number): Observable<ShoppingSession> {
    return this.request(this.client.GET('/api/shopping-sessions/{id}', { params: { path: { id } } }));
  }

  update(id: number, body: UpdateShoppingSessionRequest): Observable<ShoppingSession> {
    return this.request(this.client.PATCH('/api/shopping-sessions/{id}', { body, params: { path: { id } } }));
  }

  deleteOne(id: number): Observable<Success> {
    return this.request(this.client.DELETE('/api/shopping-sessions/{id}', { params: { path: { id } } }));
  }
}
